export default [
  {
    path: '/mensagens',
    name: 'Mensagens',
    component: () => import('./Avaliacoes'),
    meta: {
      domain: 'Mensagens',
      sidebar: true,
      icon: 'message',
      title: 'Mensagens',
      group: true,
    },
    children: [
      {
        path: '/avaliacoes',
        name: 'Avaliacoes',
        component: () => import('./Avaliacoes'),
        meta: {
          domain: 'Avaliacoes',
          icon: 'star_border',
          title: 'Avaliações',
          routerGo: '/avaliacoes',
          routerEdit: '/avaliacoes',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/Mensagens/MensagensRouter.js